import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/castle-rock-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-castle-rock-colorado",
      statusCode: 301,
    });
  },
});
